// https://usehooks.com/useEventListener/

import { useEffect, useRef } from 'react';

// Hook
export default function useEventListener(
	eventName: string,
	handler: (event: Event) => void,
	element: any = window,
): void {
	// Create a ref that stores handler
	const savedHandler = useRef<(event: Event) => void>(handler);

	// Update ref.current value if handler changes.
	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(() => {
		// Make sure element supports addEventListener.
		if (!element || !element.addEventListener) {
			return;
		}

		// Create event listener that calls handler function stored in ref.
		const eventListener = (event: Event): void => {
			savedHandler.current(event);
		};

		// Subscribe.
		element.addEventListener(eventName, eventListener);

		return (): void => {
			// Unsubscribe.
			element.removeEventListener(eventName, eventListener);
		};
	}, [eventName, element]);
}
